import React, { useEffect, useState } from 'react';
import { DefaultTheme } from '@mui/styles';

import useStyles from './icon.styles';

export interface IconProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  bold?: boolean;
}

export interface MainProps extends IconProps {
  icon: string;
  condition?: boolean;
  conditionIcon?: string;
}

interface Theme extends DefaultTheme {
  bold?: boolean;
}

const Icon = ({ bold, condition, conditionIcon, icon, ...rest }: MainProps) => {
  const [activeClass, setActiveClass] = useState<string>(icon);

  const theme: Theme = {
    bold: bold,
  };

  const classes = useStyles(theme);

  useEffect(() => {
    if (
      condition === true &&
      conditionIcon !== undefined &&
      activeClass !== conditionIcon
    ) {
      return setActiveClass(conditionIcon);
    }
    setActiveClass(icon);
  }, [condition, conditionIcon]);

  return (
    <span className={classes.iconWrapper} {...rest}>
      <i className={`${classes.icon} ${activeClass}`} />
    </span>
  );
};
export default Icon;
